import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "utils/api";
import { LoanModel } from "../../../providers/loans/loan.model";
import { useTenant } from "modules/tenant/providers/tenant-provider";

export const useDeleteLoan = () => {
  const queryClient = useQueryClient();
  const { user } = useTenant();

  return useMutation({
    mutationFn: async (loanId: string) => {
      await apiRequest("/supabase/loans/delete", {
        id: loanId,
      });
    },
    onSuccess: (_, loanId) => {
      queryClient.setQueryData<LoanModel[]>(["loans", user?.id], oldData => {
        if (!oldData) return [];
        return oldData.filter(loan => loan.id !== loanId);
      });
    },
  });
};
